import { useLayoutEffect, useRef } from 'react';

import { useAppState } from '../../AppStateProvider';
import type { WidgetItemId } from '../../domain/company_widgets';
import { appStore } from '../../services/appStore';

export const useWidgetScrollIntoView = (id: WidgetItemId) => {
  const { widgetId, companyDomain } = useAppState();
  const widgetRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!widgetId || widgetId !== id) {
      return;
    }
    setTimeout(() => {
      widgetRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 100);

    appStore.setWidgetId(undefined);
  }, [companyDomain, widgetId]);

  return widgetRef;
};
